// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"42980e3a","157":"10070b41","207":"c967f035","265":"10b7b1b2","316":"0724c2b7","525":"bc858284","615":"f0800ed0","619":"65884225","719":"51ce53c6","729":"1c11d97c","889":"6328ba22"}[chunkId] + ".chunk.js";
};